export enum SpreadsheetExportType {
  txtTab = 'TXT_TAB',
  txtComma = 'TXT_COMMA',
  txtOther = 'TXT_OTHER',
  xls = 'XLS',
  xlsx = 'XLSX',
};

export enum SpreadsheetExportNewLineType {
  noFormatting = 0,
  asSpaces = 1,
  retainFormatted = 2
};